export const services = [
  {
    id: "1",
    course: "Emergency Digital Health Kit ",
    imageSrc: "/services-images/dehk.jpeg",
    profession:
      "World's First card with Multi application using QR code, RFID & NFC Technologies. Preservation and presentation of your medical record.",
    category: "dek",
  },
  {
    id: "15",
    course: "Digital And Medical Emergency Kit ",
    imageSrc: "/services-images/dmek.png",
    profession:
      "The LifeOnPlus Medical Emergency First Aid Kit is a compact and essential emergency care kit designed to provide immediate first aid support during accidents, injuries, medical emergencies, and unexpected situations before professional medical help arrives",
    category: "dmek",
  },

  {
    id: "14",
    course: "Quick Health Checkup",
    imageSrc: "/services-images/qhc1.jpeg",
    profession:
      "Identify early signs of heart disease, stroke risk, and vascular aging in minutes with advanced non-invasive technology",
    category: "qhc",
  },
  {
    id: "5",
    course: "Body Recharge Station",
    imageSrc: "/services-images/brs1.jpeg",
    profession:
      "Revitalize your body and mind with non-invasive therapies that recharge, detox, and restore your natural energy balance.",
    category: "brs",
  },
  {
    id: "3",
    course: "Express Medical Test",
    imageSrc: "/services-images/emt2.png",
    profession:
      "Get Express medical tests at your doorstep with LifeOnPlus-fast,easy,and reliable!",
    category: "emt",
  },
  {
    id: "4",
    course: "Diagnostic Services",
    imageSrc: "/services-images/diagnosis1.jpeg",
    profession:
      "Accurate detection and analysis of health conditions through advanced invasive and non-invasive techniques.",
    category: "diagnosis",
  },

  {
    id: "6",
    course: "Wearable Technologies",
    imageSrc: "/services-images/wh.jpeg",
    profession:
      "Smart devices that track, monitor, and optimize your health in real time—anytime, anywhere.",
    category: "wt",
  },
  {
    id: "7",
    course: "Remote Patient Monitoring Tech",
    imageSrc: "/services-images/rpm.jpeg",
    profession:
      "Connecting people to personalized healthcare anytime, anywhere—digitally and seamlessly.",
    category: "rpmt",
  },
  {
    id: "8",
    course: "Scalar Energy Products",
    imageSrc: "/services-images/scp.jpeg",
    profession:
      "Harness the power of scalar energy (holistic health and wellness products) to restore balance, boost vitality, and support overall wellness.",
    category: "sep",
  },

  {
    id: "10",
    course: "Advanced Kiosk",
    imageSrc: "/services-images/kiosk.jpeg",
    profession:
      "A self-service, interactive kiosk offering instant health assessments, diagnostics, and personalized wellness insights at your fingertips.",
    category: "ak",
  },
  {
    id: "11",
    course: "AI in Healthcare",
    imageSrc: "/services-images/ai2.jpeg",
    profession:
      "Leveraging AI to deliver personalized health insights, predictive care, and real-time monitoring, ensuring smarter, more efficient healthcare.",
    category: "aih",
  },
  {
    id: "12",
    course: "Food Supplements",
    imageSrc: "/services-images/fs.jpeg",
    profession:
      "Enhance your health and vitality with scientifically-backed food supplements that fill nutritional gaps and support overall wellness.",
    category: "fs",
  },
  // {
  //   id: "9",
  //   course: "Skin Caroteniod Test",
  //   imageSrc: "/services-images/dehk.jpeg",
  //   profession:
  //     "A simple, non-invasive test that measures your skin’s carotenoid levels to assess overall health and antioxidant status.",
  //   category: "sct",
  // },
  // {
  //   id: "2",
  //   course: "Pharmacy ",
  //   imageSrc: "/services-images/dehk.jpeg",
  //   profession:
  //     "Order trusted medicines anytime,anywhere-right from your LifeOnPlus app!",
  //   category: "pharmacy",
  // },
  {
    id: "13",
    course: "Medical Devices",
    imageSrc: "/services-images/md.jpeg",
    profession:
      "Smart devices that track, monitor, and optimize your health in real time—anytime, anywhere.",
    category: "md",
  },
  {
    id: "21",
    course: "AcuGraph Body Screening",
    imageSrc: "/services-images/brs1.png",
    profession:
      "AcuGraph is a non-invasive meridian and energy balance assessment system that evaluates the body's energetic pathways based on Traditional Chinese Medicine (TCM) principles.",
    category: "brs",
    subCategory: "abs",
  },
  {
    id: "22",
    course: "Power Foot Detox",
    imageSrc: "/services-images/brs2.png",
    profession:
      "The LifeOnPlus Power Foot Detox is a wellness technology designed to provide a relaxing foot spa experience while promoting overall well-being. During the session, feet are immersed in warm water with a specialized detox device, creating a soothing and rejuvenating experience.",
    category: "brs",
    subCategory: "pfd",
  },
  {
    id: "23",
    course: "MEOL (Miracle Energy Of Life) Wellness Technology",
    imageSrc: "/services-images/brs4.jpeg",
    profession:
      "MEOL (Miracle Energy Oscillation Loop) is a non-invasive wellness technology designed to provide a relaxing and rejuvenating experience through gentle energy-based stimulation. Users simply sit on the device during a session, making it a comfortable and easy-to-use wellness solution.",
    category: "brs",
    subCategory: "meol",
  },
  {
    id: "24",
    course: "IMRS",
    imageSrc: "/services-images/brs3.png",
    profession:
      "LifeOnPlus – Bringing Advanced Non-Invasive Wellness Technologies to Everyone.",
    category: "brs",
    subCategory: "imrs",
  },
];
